import { Component, inject, OnInit } from '@angular/core';
import { DxButtonComponent, DxDataGridComponent, DxDateBoxComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { LogAccessiService } from 'src/app/shared/services/log-accessi.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-log-accessi',
  templateUrl: './log-accessi.component.html',
  styleUrls: ['./log-accessi.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoExportComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoTextsComponent,
    DxoColumnChooserComponent,
    DxDateBoxComponent,
    DxButtonComponent,
  ],
})
export class LogAccessiComponent
  extends GestArticoliBaseComponent
  implements OnInit {
  private logAccessiService = inject(LogAccessiService);
  dataSource: any;
  columnResizingMode = 'widget';
  daData: Date | null = null;
  aData: Date | null = new Date();

  ngOnInit() {
    this.daData = new Date(new Date().setMonth(new Date().getMonth() - 1));
    this.loadDataSource();
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.logAccessiService.list(this.daData, this.aData))
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Errore caricamento Log Accessi';
          });
      },
    });
  }

  cercaLog() {
    this.loadDataSource();
  }
  onExporting(e: any) {
    GridExportExcel(e, 'Log Accessi', 'Log_Accessi.xlsx');
  }
}
